import React from 'react';
import { WithDefaultLayout } from '@/components/DefautLayout';
import type { ReactElement, ReactNode } from 'react';
import { useRouter } from 'next/router';
import ArticleDetail from '@/components/blog/ArticleDetail';
import { articles } from '@/types/Blog';

type NextPageWithLayout = React.FC & {
  layout?: (page: ReactElement) => ReactNode
}

const ArticleDetailPage: NextPageWithLayout = () => {
  const router = useRouter();
  const { slug } = router.query;

  const article = articles.find(a => a.slug === slug);
  const sortedRelatedArticles = [...articles].sort((a, b) => {
    const timeA = new Date(`${a.date} ${a.time}`).getTime();
    const timeB = new Date(`${b.date} ${b.time}`).getTime();
    return timeB - timeA;
  });

  if (!article) {
    return <div>Article not found</div>;
  }

  return (
    <div className='flex flex-col items-center w-full bg-gray-100 -mb-32 pb-5'>
      <ArticleDetail article={article} sortedRelatedArticles={sortedRelatedArticles} />      
    </div>
  );
}

ArticleDetailPage.layout = WithDefaultLayout;

export default ArticleDetailPage;